import { textVariants } from './Text.cva';

export interface TextProps extends React.HTMLAttributes<HTMLSpanElement> {
  className?: string;
  as?: 'span' | 'p' | 'strong' | 'b';
  size?: '2xs' | 'xs' | 'sm' | 'base' | 'lg' | 'xl';
  textColor?: 'primary' | 'white' | 'black';
  decoration?: 'underline' | 'lineThrough';
  shouldTruncate?: boolean;
  children: React.ReactNode;
}

export function Text({
  className,
  as = 'span',
  size = 'base',
  textColor,
  decoration,
  shouldTruncate = false,
  children,
  ...props
}: TextProps) {
  const Element = as;

  return (
    <Element
      className={textVariants({
        as,
        size,
        textColor,
        decoration,
        shouldTruncate,
        className,
      })}
      {...props}
    >
      {children}
    </Element>
  );
}

export default Text;
